module.exports = __webpack_public_path__ + "img/mac_download_btn_en.f4275ccb.svg";